import {Injectable} from '@angular/core';
import {ExgMapGoogleAPIWrapper} from '../../services';
import {ExgMapHeatmapLayerDirective} from '../../directives';

declare var google: any;

@Injectable()
export class ExgMapHeatmapLayerManagerService {
  private _layers: Map<ExgMapHeatmapLayerDirective, Promise<google.maps.visualization.HeatmapLayer>> =
    new Map<ExgMapHeatmapLayerDirective, Promise<google.maps.visualization.HeatmapLayer>>();

  constructor(
    private _wrapper: ExgMapGoogleAPIWrapper
  ) {
  }


  addHeatmapLayer(layer: ExgMapHeatmapLayerDirective): Promise<google.maps.visualization.HeatmapLayer> {
    const options: google.maps.visualization.HeatmapLayerOptions = {
      gradient: layer.gradient === null ? undefined : layer.gradient,
      dissipating: layer.dissipating,
      maxIntensity: layer.maxIntensity === null ? undefined : layer.maxIntensity,
      opacity: layer.opacity,
      radius: layer.radius === null ? undefined : layer.radius,
      data: []
    };
    const newLayer = this._wrapper.createHeatmapLayer(options);
    this._layers.set(layer, newLayer);
    return newLayer;
  }

  setOptions(layer: ExgMapHeatmapLayerDirective, options: google.maps.visualization.HeatmapLayerOptions): Promise<void> {
    // @ts-ignore
    return this._layers.get(layer)
      .then(l => l.setOptions(options));
  }

  setData(layer: ExgMapHeatmapLayerDirective, data: google.maps.MVCArray<google.maps.LatLng
      | google.maps.visualization.WeightedLocation>
    | (google.maps.LatLng
    | google.maps.visualization.WeightedLocation)[] | null): Promise<void> {
    // @ts-ignore
    return this._layers.get(layer)
      .then(l => l.setData(data as any));
  }

  deleteHeatmapLayer(layer: ExgMapHeatmapLayerDirective): Promise<void> {
    // @ts-ignore
    return this._layers.get(layer).then(l => {
      l.setMap(null);
      this._layers.delete(layer);
    });
  }
}
